export default function Image() {
  return {}
}
